'use client'
import {useEffect, useState} from 'react'

const useSession = <T>(
	key: string,
	initialValue?: T,
	raw?: boolean,
): [T, (value: T) => void] => {
	const isBrowser = typeof window !== 'undefined'

	if (!isBrowser) {
		return [initialValue as T, () => {}]
	}

	const [state, setState] = useState<T>(() => {
		try {
			const sessionStorageValue = sessionStorage.getItem(key)
			if (typeof sessionStorageValue !== 'string') {
				sessionStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue))
				return initialValue
			} else {
				return raw ? sessionStorageValue : JSON.parse(sessionStorageValue || 'null')
			}
		} catch {
			// If user is in private mode or has storage restriction
			// sessionStorage can throw. JSON.parse and JSON.stringify
			// can throw, too.
			return initialValue
		}
	})

	useEffect(() => {
		try {
			const serializedState = raw ? String(state) : JSON.stringify(state)
			sessionStorage.setItem(key, serializedState)
		} catch {
			// If user is in private mode or has storage restriction
			// sessionStorage can throw. Also JSON.stringify can throw.
		}
	})

	return [state, setState]
}

export default useSession
